import {
  BaseCfComponent, CfRepeatableItem, FormFieldType, SurfaceLevel
} from '../../types';
import { type ButtonProps } from '../atoms/Button';
import RadioOption from '../atoms/RadioOption';
import SelectInput from '../atoms/SelectInput';
import TextInput from '../atoms/TextInput';

enum FieldVariant {
  FullWidth = 'Full-width',
  HalfWidth = 'Half-width'
}

export interface FormFieldProps extends BaseCfComponent {
  fields: {
    allowMultiple?: boolean;
    appendToComment?: boolean;
    defaultValue?: string;
    heading: string;
    isBusinessEmail?: boolean;
    isLabelOutside?: boolean;
    isRequired?: boolean;
    label: string;
    name: string;
    options?: CfRepeatableItem[];
    placeholder: string;
    systemTitle: string;
    type: FormFieldType;
    variant?: FieldVariant;
  }
  onChange: (name: string, value: string | string[]) => void;

  // Optional props for inline CTA
  buttonProps?: ButtonProps;
  onInvalid?: () => void;
  surfaceLevel?: SurfaceLevel;
  value?: boolean | number | string | string[];
}

const FormFieldComponent = ({
  buttonProps,
  fields,
  onChange,
  onInvalid,
  surfaceLevel,
  value,
}: FormFieldProps) => {
  const {
    allowMultiple = false,
    heading = '',
    isBusinessEmail,
    isLabelOutside,
    isRequired,
    label,
    name,
    options,
    placeholder,
    type,
  } = fields;

  const getInput = () => {
    if (type === FormFieldType.Select) {
      return (
        <SelectInput
          key={name}
          allowMultiple={allowMultiple}
          isRequired={isRequired}
          label={label}
          name={name}
          onChange={onChange}
          options={options ?? []}
          surfaceLevel={surfaceLevel}

          // @ts-expect-error Type 'boolean' is not assignable to type 'false'
          value={value}
        />
      );
    }

    if (type === FormFieldType.Radio) {
      return (

        <RadioOption
          key={name}
          isRequired={isRequired}
          label={label}
          name={name}
          onChange={onChange}
          options={options ?? []}
          surfaceLevel={surfaceLevel}

          // @ts-expect-error Type 'boolean' is not assignable to type 'false'
          value={value}
        />
      );
    }

    // Everything else is a text
    return (
      <TextInput
        key={name}
        buttonProps={buttonProps}
        hasHeading={!!heading}
        isBusinessEmail={!!isBusinessEmail}
        isLabelOutside={isLabelOutside}
        isRequired={isRequired}
        label={label}
        name={name}
        onChange={onChange}
        onInvalid={onInvalid}
        placeholder={placeholder}
        surfaceLevel={surfaceLevel}
        type={type}

        // @ts-expect-error Type 'boolean' is not assignable to type 'false'
        value={value}
      />
    );
  };

  return (
    <>
      {heading && <p className="text-text-primary text-h4 font-bold mt-6">{heading}</p>}
      {getInput()}
    </>
  );
};

export default FormFieldComponent;
